import {
  IGetFeatureAvailableResponse,
  IGetFeaturesByCustomerIdResponse,
} from '../types';
import * as featuresApi from '../api/index';

export const getFeaturesByCustomerId = async (
  customerId: string
): Promise<IGetFeaturesByCustomerIdResponse> =>
  featuresApi.getFeaturesByCustomerId(customerId);

export const IsFeatureAvailableForCustomer = async (
  customerId: string,
  featureName: string
): Promise<IGetFeatureAvailableResponse> =>
  featuresApi.IsFeatureAvailableForCustomer(customerId, featureName);
